import { render } from "./QuestionAlert.vue?vue&type=template&id=b8971d0c&scoped=true"
import script from "./QuestionAlert.vue?vue&type=script&lang=js"
export * from "./QuestionAlert.vue?vue&type=script&lang=js"

import "./QuestionAlert.vue?vue&type=style&index=0&id=b8971d0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8971d0c"]])

export default __exports__